module.exports = __webpack_public_path__ + "images/landing-page-resources-bg.jpg";